import { useAuth } from '../context/AuthContext';
import { useTrialStatus } from './useTrialStatus';

/**
 * Hook pour vérifier les permissions selon le plan
 */
export const useFeatureAccess = () => {
  const { user } = useAuth();
  const { isTrialActive, isPro, restaurantInfo } = useTrialStatus();
  
  // Récupérer le plan actuel depuis restaurantInfo
  const currentPlan = restaurantInfo?.plan || 'free';
  
  // Pendant l'essai actif (14 jours) → Accès COMPLET comme PLUS
  const hasFullAccess = isTrialActive || currentPlan === 'plus';
  
  // Permissions par feature
  // Import facture OCR : UNIQUEMENT PLUS (ou trial)
  const canImportInvoice = hasFullAccess;
  const canUseLogo = hasFullAccess;
  const canUseFavorites = hasFullAccess;
  
  // Multi-utilisateurs : PRO et PLUS
  const canUseMultiUser = isTrialActive || currentPlan === 'pro' || currentPlan === 'plus';
  
  // Fonction pour obtenir le message d'upgrade
  const getUpgradeMessage = (feature) => {
    const messages = {
      invoice: "L'import de factures PDF (OCR) est disponible uniquement dans le plan Plus (54€/mois)",
      logo: "Le logo restaurant personnalisé est disponible dans le plan Plus (54€/mois)",
      favorites: "Les favoris et modèles de commandes sont disponibles dans le plan Plus (54€/mois)",
      multiUser: "La gestion multi-utilisateurs est disponible à partir du plan Pro (39€/mois)"
    };
    return messages[feature] || "Cette fonctionnalité nécessite un plan supérieur";
  };
  
  // Fonction pour obtenir le plan requis
  const getRequiredPlan = (feature) => {
    const requiredPlans = {
      invoice: 'plus',
      logo: 'plus',
      favorites: 'plus',
      multiUser: 'pro'
    };
    return requiredPlans[feature] || 'plus';
  };
  
  return {
    currentPlan,
    isTrialActive,
    hasFullAccess,
    canImportInvoice,
    canUseLogo,
    canUseFavorites,
    canUseMultiUser,
    getUpgradeMessage,
    getRequiredPlan
  };
};
